export default __webpack_public_path__ + "static/media/story_img_3.88c14ddc.jpeg";